export default "__VITE_ASSET__bb2e735a__"